import { SlideOnMount } from '../Animations'
import { Page } from '../Routing'
import { PrimaryTeamMemberCard } from './PrimaryTeamMemberCard'
import { TeamMemberCard } from './TeamMemberCard'
import { AddAgentCard } from './AddAgentCard'
import { Flex, LoadingSpinner, Text } from '@homebotapp/hb-react-component-catalog'
import { selectClientId } from 'src/store/selectors/client'
import { useSelector } from 'react-redux'
import { useCallback, useState } from 'react'
import { selectCustomerIsRealEstateAgent } from '../../../store/selectors/customerProfile'
import { selectClientTeamMemberships } from '../../../store/selectors/clientTeamMemberships'
import { useCanViewHbnTeamPage } from '../../../hooks/useCanViewHbnTeamPage'
import { RedirectToHomeDigest } from '../Navigation'

export const TeamPanel = () => {
  const [isLoanOfficerLoading, setIsLoanOfficerLoading] = useState(true)
  const clientTeamMemberships = useSelector(selectClientTeamMemberships)
  const clientId = useSelector(selectClientId) as string
  const isREA = useSelector(selectCustomerIsRealEstateAgent)
  const canViewHbnTeamPage = useCanViewHbnTeamPage()

  const firstMembership = clientTeamMemberships?.data?.[0]

  const isLoading = isLoanOfficerLoading
  const handleLoanOfficerLoadingChange = useCallback((loading: boolean) => {
    setIsLoanOfficerLoading(loading)
  }, [])

  // Redirect if user can't view the team page
  if (!canViewHbnTeamPage) {
    return <RedirectToHomeDigest />
  }

  return (
    <Page>
      <SlideOnMount>
        <Flex pt={8} gap={8} flexDir='column' alignItems='center' w='100%' px={[4, 6, 8]}>
          <PrimaryTeamMemberCard onLoadingChange={handleLoanOfficerLoadingChange} />
          {isLoading ? (
            <Flex justify='center' align='center' minH='200px'>
              <LoadingSpinner />
            </Flex>
          ) : (
            <>
              {!firstMembership && !isREA && <AddAgentCard clientId={clientId} />}
              {firstMembership && <TeamMemberCard membership={firstMembership} clientId={clientId} />}
            </>
          )}
        </Flex>
      </SlideOnMount>
    </Page>
  )
}

export default TeamPanel
